// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__nPgXd","container":"card_container__EKQqP","title":"card_title__2NPkW","description":"card_description__3RBWQ"};